import {connect} from 'react-redux';

import {CalendarsPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../srcCommon/helpers/reselectHelpers';
import {LocalPreferencesSizesEnum} from '../../models/api/localPreferencesModel';
import {updateSizeAction} from '../../store/data/localPreferences/localPreferencesActions';
import {getSizes} from '../../store/data/localPreferences/localPreferencesSelectors';
import {createOrUpdateCalendarEventDraftAction} from '../../store/panels/calendars/calendarsPanelActions';
import {makeGetCanCreateNewEvent} from '../../store/panels/calendars/calendarsPanelSelectors';
import {PopupLargeCalendars} from './popupLargeCalendars';

/*
 * Props.
 */

interface PopupLargeCalendarsContainerProps {
  panelId: CalendarsPanelId;
}

/*
 * Selectors.
 */

const getLeftPanelWidth = createSelector(
  [getSizes],
  (sizes) => sizes[LocalPreferencesSizesEnum.CALENDARS_POPUP_LEFTPANEL],
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  canCreateNewEvent: makeGetCanCreateNewEvent(),
  leftPanelWidth: getLeftPanelWidth,
}));

const mapDispatchToProps = makeMapDispatchToProps<PopupLargeCalendarsContainerProps>()(({panelId}) => ({
  onNewEventClick: () => createOrUpdateCalendarEventDraftAction(panelId),
  onLeftPanelWidthChange: (newWidth: number) =>
    updateSizeAction(LocalPreferencesSizesEnum.CALENDARS_POPUP_LEFTPANEL, newWidth),
}));

export const PopupLargeCalendarsContainer = connect(mapStateToProps, mapDispatchToProps)(PopupLargeCalendars);
